/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const MergeChecksListWrapper = styled.ul({
  margin: 0,
  paddingLeft: token('space.250'),
});
